import {
  ID,
  UUID,
  FetchItemsCacheKey,
  FetchItemsLimit,
  TextFilterType,
  FetchItemsGqlQuery,
  IdFilterType
} from '../../types';

import { UserID } from '../users/usersTypes';

export type ProductSearchID = ID;
export type ProductSearchUUID = UUID;
export type ProductSearchSearchValue = string;
export type ProductSearchUserID = UserID;

export type FetchProductSearchesCacheKey = FetchItemsCacheKey;
export type FetchProductSearchesCacheKeys = FetchProductSearchesCacheKey[];
export type FetchProductSearchesGqlQuery = FetchItemsGqlQuery;
export type FetchProductSearchesLimit = FetchItemsLimit;

export type FetchProductSearchesSort = FetchProductSearchesSortTypes[];

export interface FetchProductSearchesFilters {
  searchValue?: TextFilterType;
  userId?: IdFilterType;
}

export enum FetchProductSearchesSortTypes {
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}
